import { useSearch } from '@tanstack/react-router';

import { isNewUserFlag } from '../utils/isNewUserFlag';

/**
 * `?newUser=true` — метка «этот аккаунт только что создан». Её ставят форма регистрации
 * ([SignUpForm]) и возврат из OAuth (teamplay-user, `OAuth2RedirectUtils.resolveFinalRedirect`
 * и deep link в приложение). По ней открывается онбординг.
 */
export const useIsNewUser = () =>
  useSearch({ strict: false, select: (search) => isNewUserFlag(search.newUser) });
